import {
  useCheckDocumentAccessQuery,
  useGetUserAvailableIntegrationsQuery,
} from 'modules/integrations/integrationsApi';

type GoogleAccessResponse =
  | 'accessible'
  | 'inaccessible'
  | 'googleDisabled' // This represents google being disabled for the entire workspace
  | 'notGoogle'
  | 'unknown'
  | 'checking'
  | 'loading'
  | 'error';

export const useCheckGoogleLink = (
  link: string,
  isUrl: boolean
): { status: GoogleAccessResponse; fileName?: string } => {
  const { data: integrations, isLoading: isIntegrationsLoading } =
    useGetUserAvailableIntegrationsQuery();

  const {
    data: accessResponse,
    error: accessError,
    isFetching: isCheckingAccess,
  } = useCheckDocumentAccessQuery(
    { url: link as string },
    {
      // /has-access returns 403 if google is disabled, make sure not to call in that case
      skip: !link || isIntegrationsLoading || !isUrl || !integrations?.isGoogleEnabled,
    }
  );

  // TODO: Currently no case if google is enabled but the user has not linked that service e.g Docs
  if (isIntegrationsLoading) return { status: 'loading' };
  // Google is disabled for this workspace, link is not checked
  if (integrations?.isGoogleEnabled === false) return { status: 'googleDisabled' };
  if (accessError) return { status: 'error' };
  if (isCheckingAccess) return { status: 'checking' };
  if (accessResponse && !accessResponse.isGoogle) return { status: 'notGoogle' };
  if (accessResponse?.isGoogle && !accessResponse.hasAccess) return { status: 'inaccessible' };
  if (accessResponse?.isGoogle && accessResponse.hasAccess)
    return { status: 'accessible', fileName: accessResponse.fileName };

  return { status: 'unknown' };
};
